<template>
	<div class="g-s-a-w index">
		<Swiper :shouyecode="shouyecode" />
	</div>
</template>

<script>
	import Swiper from "@/components/english/swiper/swiper.vue";

	export default {
		name: "index",
		data() {
			return {
				value: [],
				// 首页轮播的code
				shouyecode: "500",
				// 国内轮播code
				guoneicode: "200",
				// 国际轮播code
				guojicode: "300",
				indexDataIP: '',
				newsList: '',
				count: 0,
			};
		},
		components: {
			Swiper,
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				this.timingRemove();
			},
			timingRemove() {
				setTimeout(() => {
					var dataIp = {
						value: {
							ip: returnCitySN['cip'],
							area: returnCitySN["cname"],
							cookies: this.$cookies.get("ecun"),
						},

					};
					this.$axios
						.post("/CustmerStatistics/getCustmerStatistics", dataIp)
						.then((res) => {

						})
						.catch((err) => {

						});
				}, 2000)
			},

			//跳转
			routerLinkdd(link) {
				
				this.$router.push(link);
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../../../assets/css/english-css/index/index.scss";
</style>